// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2LlZd","header":"PatientBlock_header__3Ry2p","label":"PatientBlock_label__3v9MV","option":"PatientBlock_option__3yk-E"};